<ng-container *ngIf="loaded$ | async; else loading">
  <a  [attr.aria-label]="'miniCart.item' | cxTranslate: { count: quantity$ | async }" (click)="openModal(); $event.preventDefault();" style="cursor: pointer;">
    <div class="mini-cart-count">
      ({{ 'miniCart.count' | cxTranslate: { count: quantity$ | async } }}
      {{
        quantity$
          | async
          | i18nPlural
            : {
                '=0': 'PRODUCTOS DEL CARRITO',
                '=1': 'PRODUCTO DEL CARRITO',
                other: 'PRODUCTOS DEL CARRITO'
              }
      }})
    </div>
    <div class="mini-cart-total" *ngIf="total$ | async as total">
      {{ total }}
    </div>
    <i-bs name="cart4" style="margin-left: 5px"></i-bs>
  </a>
</ng-container>
<ng-template #loading>
  <a>
    <div class="mini-cart-count ghost">Cargando...</div>
    <i-bs name="cart4" style="margin-left: 5px"></i-bs>
  </a>
</ng-template>
